import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { LoaderDatatableService } from 'src/app/core/services/loader-datatable.service';
import { ActiveRoutesService } from 'src/app/pages/active-routes/services/active-routes.service';
import { HomeService } from 'src/app/pages/home/services/home.service';
import { MyServicesService } from 'src/app/pages/my-services/services/my-services.service';
import { Status } from '../status/enum/Status.enum';
import { CancelModalComponent } from './components/cancel-modal/cancel-modal.component';
import { datatableData } from './interfaces/DatatableData.interface';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { MenuMoreOption } from '../more-options-table-row/more-options-table-row.component';
import { MoreOptionsEnum } from '../more-options-table-row/more-options.enum';


import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { EditServiceModalComponent } from 'src/app/pages/my-services/components/edit-service-modal/edit-service-modal.component';
import { ReportModalComponent } from 'src/app/pages/active-routes/components/report-modal/report-modal.component';
import { AlertType } from 'src/app/core/services/alert.service';
import * as moment from 'moment';
import { RoleFilterSelected } from '../role-filter-dropdown-row/role-filter-dropdown-row.component';
import { ServiceListItem, ServiceListResponse, ServicesPageResponse } from 'src/app/pages/home/interfaces/HomeData.interface';
import { RoleFilterService } from 'src/app/services/role-filter.service';
import { hasTransitProductKey } from 'src/app/shared/functions/transit-functions';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
})
export class DatatableComponent implements OnChanges {
  @ViewChild('contextMenu') contextMenu: ElementRef | undefined;
  @Input() isHomePage = false;
  @Input() isMyServicesToday = false;
  @Input() isMyServicesNext = false;
  @Input() isMyServicesHistory = false;
  @Input() isActiveRoutesDatatable = false;
  @Input() searchValue = '';
  @Input() selectedStatus: number[] = [];
  @Input() rangeValue: Date[] | undefined;
  @Input() data: datatableData[] = [];

  @Input() RoleFilter: RoleFilterSelected = this.roleFilterService.getEmptyRoleFilter()

  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  contextMenuVisible = false;
  contextMenuPosition: { top: string; left: string } = { top: '0px', left: '0px' };

  page = 1;
  pageCount = 1;
  limit = 9;
  loading = false;
  isLoadingData = false;
  private debounceTimer: any;
  private initialLoadDone = false;
  selectedOrderHash: string | null = null;
  rawServiceData: any[] = [];

  statusEnum = Status;
  bsModalRef?: BsModalRef;
  showSuccessDeleteServiceAlert = false;

  constructor(
    private readonly homeRequest: HomeService,
    private readonly myServicesRequest: MyServicesService,
    private readonly activeRoutesRequest: ActiveRoutesService,
    private readonly loaderDatatable: LoaderDatatableService,
    private readonly alertService: AlertService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly router: Router,
    private readonly translateService: TranslateService,
    private readonly modalService: BsModalService,
    private readonly roleFilterService: RoleFilterService
  ) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (!this.initialLoadDone && (this.isMyServicesHistory || this.isMyServicesToday || this.isMyServicesNext || this.isHomePage)) {
      this.initialLoadDone = true;
      await this.loadData(this.searchValue);
      return;
    }

    if (changes['searchValue'] && !changes['searchValue'].firstChange) {
      this.page = 1;
      if (!this.isLoadingData) {
        await this.loadData(this.searchValue);
      }
    }

    if (changes['RoleFilter'] && !changes['RoleFilter'].firstChange) {
      this.page = 1;
      if (!this.isLoadingData) {
        await this.loadData(this.searchValue);
      }
    }

    if (changes['data'] && !changes['data'].firstChange) {
      this.data = changes['data'].currentValue;
    }
  }

  private async loadHomePageData(RoleFilter: RoleFilterSelected) {
    this.limit = 6;
    this.loaderDatatable.show();
    this.loading = true;
    try {
      const data: ServiceListResponse | undefined = await this.homeRequest.servicesList(RoleFilter).toPromise();
      if (data) this.data = this.mapServiceData(data);
    } catch (error) {
      console.error('Error loading home page data', error);
    } finally {
      this.loaderDatatable.hide();
      this.loading = false;
    }
  }

  private async loadMyServicesTodayData(searchValue: string, RoleFilter: RoleFilterSelected) {
    this.loaderDatatable.show();
    this.loading = true;
    try {
      let data: ServicesPageResponse | undefined;
      if (searchValue && searchValue.trim() !== '') {
        data = await this.myServicesRequest.todayServices(this.page, searchValue, RoleFilter).toPromise();
      } else {
        data = await this.myServicesRequest.todayServices(this.page, "", RoleFilter).toPromise();
      }
      if (data) {
        this.handleServiceDataResponse(data);
      }
    } catch (error) {
      console.error('Error loading today services', error);
    } finally {
      this.loaderDatatable.hide();
      this.loading = false;
    }

  }

  private async loadMyServicesHistoryData(searchValue: string, RoleFilter: RoleFilterSelected) {
    this.loaderDatatable.show();
    this.loading = true;
    try {
      let data: ServicesPageResponse | undefined;

      let dateFrom: string | undefined;
      let dateTo: string | undefined;
      if (this.rangeValue && this.rangeValue.length === 2) {
        dateFrom = this.formatDate(this.rangeValue[0]);
        dateTo = this.formatDate(this.rangeValue[1]);
      }

      if (searchValue && searchValue.trim() !== '') {
        data = await this.myServicesRequest.historyServices(this.page, searchValue, RoleFilter, this.selectedStatus, dateFrom, dateTo).toPromise();
      } else {
        data = await this.myServicesRequest.historyServices(this.page, "", RoleFilter, this.selectedStatus, dateFrom, dateTo).toPromise();
      }
      if (data) {
        this.handleServiceDataResponse(data);
      }

    } catch (error) {
      console.error('Error loading history services', error);
    } finally {
      this.loaderDatatable.hide();
      this.loading = false;
    }
  }

  private async loadMyServicesNextData(searchValue: string, RoleFilter: RoleFilterSelected) {
    this.loaderDatatable.show();
    this.loading = true;
    try {
      let data: ServicesPageResponse | undefined;
      if (searchValue && searchValue.trim() !== '') {
        data = await this.myServicesRequest.nextServices(this.page, searchValue, RoleFilter).toPromise();
      } else {
        data = await this.myServicesRequest.nextServices(this.page, "", RoleFilter).toPromise();
      }
      if (data) {
        this.handleServiceDataResponse(data);
      }
    } catch (error) {
      console.error('Error loading next services', error);
    } finally {
      this.loaderDatatable.hide();
      this.loading = false;
    }
  }
  private async loadActiveRoutesList(searchValue: string, RoleFilter: RoleFilterSelected) {
    this.loaderDatatable.show();
    this.loading = true;
    try {
      const data = await this.activeRoutesRequest
        .activeRoutesList(this.page, searchValue, RoleFilter)
        .toPromise();
      this.handleServiceDataResponse(data);
    } catch (error) {
      console.error('Error loading active routes', error);
    } finally {
      this.loaderDatatable.hide();
      this.loading = false;
    }
  }

  private mapServiceData(data: ServiceListResponse): datatableData[] {
    return data.map((service: ServiceListItem): datatableData => {
      const serviceDate = new Date(service['ServiceDate']);
      const date = serviceDate.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      const day = serviceDate.toLocaleDateString('es-ES', { weekday: 'long' });
      return {
        orderHash: service['OrderHash'],
        plateNumber: service['LicensePlate'],
        date,
        day: day,
        hour: service['ServiceTime'],
        services: service['ProductTypes'],
        productKeys: service['LocalizationKeys'],
        pickUpAddress: service['OriginAddress'],
        returnAddress: service['DestinationAddress'],
        serviceReporter: service['ServiceReporter'],
        driver: service['DriverName'],
        status: service['OrderStatus'],
        MoreOptionData: this.buildMoreOptions(service['OrderStatus'], service['PickUpTime'], service['CanEdit'])
      };
    });
  }

  private handleServiceDataResponse(data: ServicesPageResponse) {
    if (data['Page']) this.page = data['Page'];
    if (data['PageCount']) this.pageCount = data['PageCount'];

    this.rawServiceData = data['Services'];
    this.data = this.mapServiceData(data['Services']);
  }

  get showDataWithLimit(): datatableData[] {
    return this.data.slice(0, this.limit);
  }

  isTransitService(data: datatableData): boolean {
    return hasTransitProductKey(data.productKeys);
  }

  async loadData(searchValue: string) {
    if (this.isLoadingData) {
      return;
    }

    this.isLoadingData = true;
    try {
      switch (true) {
        case this.isHomePage:
          await this.loadHomePageData(this.RoleFilter);
          break;
        case this.isMyServicesToday:
          await this.loadMyServicesTodayData(searchValue, this.RoleFilter);
          break;
        case this.isMyServicesHistory:
          await this.loadMyServicesHistoryData(searchValue, this.RoleFilter);
          break;
        case this.isMyServicesNext:
          await this.loadMyServicesNextData(searchValue, this.RoleFilter);
          break;
        case this.isActiveRoutesDatatable:
          await this.loadActiveRoutesList(searchValue, this.RoleFilter);
          break;
        default:
          this.data = [];
          break;
      }
    } finally {
      this.isLoadingData = false;
    }
  }

  async applyFiltersWithData(filters: any): Promise<void> {

    if (filters.DateFrom || filters.DateTo) {

      const dateFrom = filters.DateFrom ? new Date(filters.DateFrom) : new Date();
      const dateTo = filters.DateTo ? new Date(filters.DateTo) : new Date();
      this.rangeValue = [dateFrom, dateTo];
    } else {
      this.rangeValue = undefined;
    }

    if (filters.Statuses && Array.isArray(filters.Statuses)) {
      this.selectedStatus = filters.Statuses;
    }

    if (filters.RoleFilter) {
      this.RoleFilter = filters.RoleFilter;
    }

    this.page = 1;

    await this.loadData(this.searchValue);
  }

  async moreOptionsAction(optionId: MoreOptionsEnum, data: datatableData): Promise<void> {
    switch (optionId) {
      case MoreOptionsEnum.DETAIL:
        this.openDetails(data.orderHash);
        break;
      case MoreOptionsEnum.DOWNLOAD_SERVICE_REPORT:
        await this.openReportModal(false, data.orderHash);
        break;
      case MoreOptionsEnum.EDIT:
        this.openEditModal(data.orderHash);
        break;
      case MoreOptionsEnum.CANCEL:
        this.openCancelModal(data.orderHash, data.status);
        break;
      case MoreOptionsEnum.DOWNLOAD_ECONOMIC_REPORT:
        await this.openReportModal(true, data.orderHash);
        break;
      default:
        break;
    }
  }

  async openReportModal(isEconomic: boolean, orderHash: string): Promise<void> {
    try {
      const detailsData = await this.activeRoutesRequest.activeRoutesDetails(orderHash).toPromise();
      const initialState = {
        detailsData: detailsData,
        orderHash: orderHash,
        isEconomicReport: isEconomic,
        autoDownload: true,
        hideContent: true
      };

      const modalOptions: ModalOptions = {
        initialState,
        class: 'modal-dialog-centered modal-class-template-720',
      };
      this.modalService.show(ReportModalComponent, modalOptions);
    } catch (error) {
      this.alertService.showAlert({
        text: this.translateService.instant('ERRORS.DOWNLOAD_REPORT'),
        type: AlertType.ERROR,
        duration: 5000
      });
    }
  }

  private buildMoreOptions(status: number, pickupTime: string, canEdit: boolean): MenuMoreOption[] {
    return [
      {
        Id: MoreOptionsEnum.DETAIL,
        Text: this.translateService.instant('MORE_OPTIONS.DETAIL'),
        Icon: 'assets/icons/datatable-eye.svg',
        Alt: this.translateService.instant('MORE_OPTIONS.DETAIL'),
      },
      {
        Id: MoreOptionsEnum.DOWNLOAD_ECONOMIC_REPORT,
        Text: this.translateService.instant('MORE_OPTIONS.DOWNLOAD_ECONOMIC_REPORT'),
        Icon: 'assets/icons/cloud-download-thin.svg',
        Alt: this.translateService.instant('MORE_OPTIONS.DOWNLOAD_ECONOMIC_REPORT'),
      },
      {
        Id: MoreOptionsEnum.DOWNLOAD_SERVICE_REPORT,
        Text: this.translateService.instant('MORE_OPTIONS.DOWNLOAD_SERVICE_REPORT'),
        Icon: 'assets/icons/cloud-download-thin.svg',
        Alt: this.translateService.instant('MORE_OPTIONS.DOWNLOAD_SERVICE_REPORT'),
        Class: (status <= this.statusEnum.PickingUp) ? 'disable-span' : undefined
      },
      {
        Id: MoreOptionsEnum.EDIT,
        Text: this.translateService.instant('MORE_OPTIONS.EDIT'),
        Icon: 'assets/icons/pencil-alt.svg',
        Alt: this.translateService.instant('MORE_OPTIONS.EDIT'),
        Class: !canEdit ? 'disable-span' : undefined,
        DisabledMessage: !canEdit ? this.translateService.instant('MORE_OPTIONS.EDIT_LOCK_MSG') : undefined
      },
      {
        Id: MoreOptionsEnum.CANCEL,
        Text: this.translateService.instant('MORE_OPTIONS.CANCEL'),
        Icon: 'assets/icons/datatable-trash-red.svg',
        Alt: this.translateService.instant('MORE_OPTIONS.CANCEL'),
        Class: this.isNowBefore(pickupTime) && (status === 1 || status === 2) ? 'red-span' : 'disable-span'
      }
    ];
  }

  isNowBefore(dateTimeString: string) {
    const targetDate = moment(dateTimeString);
    return moment().isBefore(targetDate);
  }

  openEditModal(orderHash: string) {
    let config = {
      class: 'modal-class-template-500',
      backdrop: true,
      initialState: {
        OrderHash: orderHash
      }
    };

    let modalRefEdit = this.modalService.show(EditServiceModalComponent, config);
    modalRefEdit?.onHidden?.pipe(take(1)).subscribe(() => {
      const result = modalRefEdit.content?.onClose?.getValue(); // Captura el último valor emitido
      if (result) {
        this.loadData(this.searchValue)
      }
    });
  }
  setPage(page: number) {
    if (this.page != page) {
      this.page = page;
      this.pageChange.emit(this.page);
      this.loadData(this.searchValue);
    }
  }

  get startIndex() {
    return (this.page - 1) * this.pageCount;
  }

  get endIndex() {
    return Math.min(this.startIndex + this.pageCount - 1, this.page - 1);
  }

  openContextMenu(event: MouseEvent, orderHash: string, isButtonClick = false): void {
    event.preventDefault();
    event.stopPropagation();

    this.closeContextMenu();

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let x: number, y: number;

    if (isButtonClick) {
      const buttonRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
      x = buttonRect.right;
      y = buttonRect.top;
    } else {
      x = event.clientX;
      y = event.clientY;
    }

    if (x + 250 > viewportWidth) {
      x = viewportWidth - 300;
    }

    if (y + 200 > viewportHeight) {
      y = viewportHeight - 200;
    }

    this.contextMenuPosition = {
      top: `${y}px`,
      left: `${x}px`,
    };
    this.selectedOrderHash = orderHash;
    this.contextMenuVisible = true;

    this.changeDetectorRef.detectChanges();
  }

  closeContextMenu(): void {
    this.contextMenuVisible = false;
    this.selectedOrderHash = null;
  }
  downloadFile(data: Blob, filename: string) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  openCancelModal(orderHash: string, status: number): void {
    const initialState = {
      orderHash: orderHash,
      status: status,
    };

    const config = {
      class: 'modal-class-template',
      backdrop: true,
      ignoreBackdropClick: false,
      initialState: initialState
    };

    const modalRef = this.modalService.show(CancelModalComponent, config);
    modalRef.onHidden?.subscribe((result: string) => {
      if (result === "true") {
        this.showSuccessDeleteServiceAlert = true;
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    })
  }

  onAlertClosed(): void {
    this.showSuccessDeleteServiceAlert = false;
    this.alertService.setShowAlert(false);
  }
  handleRowClick(event: MouseEvent, orderHash: string) {
    const target = event.target as HTMLElement;

    if (target.closest('app-more-options-table-row')) {
      return;
    }

    this.openDetails(orderHash);
  }

  openDetails(orderHash: string): void {
    this.router.navigate(['/active-routes', orderHash, 'detail']);
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  applyFilters(): void {
    if (this.isLoadingData) {
      return;
    }
    this.page = 1;
    this.loadData(this.searchValue);
  }

}
